import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import tables from "../../../../Data/Tables/Customers/Statement/tables";
import headers from "../../../../Data/Tables/Customers/Statement/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_invoices } from "../../../../Controllers/Sales/Invoices";

const CustomerOutstandingStatement = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [summary, setSummary] = useState({
    totalOutstanding: 0,
    totalInvoices: 0,
    overdueAmount: 0,
  });
  const { id } = useParams();
  localStorage.setItem("Customer_Id", id);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      payment: headerdata?.payment_status,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const calculateOutstanding = (invoice) => {
    const total = invoice.total || 0;
    const paid =
      invoice.payments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;
    return total - paid;
  };

  const fetchSummary = async () => {
    try {
      const params = {
        customer: id,
        source: "Customer_Statement",
      };

      const response = await get_all_invoices(params);

      if (response?.status) {
        const invoices = response?.data?.data || [];
        let totalOutstanding = 0;
        let overdueAmount = 0;

        invoices.forEach((invoice) => {
          const outstanding = calculateOutstanding(invoice);
          totalOutstanding += outstanding;

          if (invoice.due_date && outstanding > 0) {
            if (new Date(invoice.due_date) < new Date()) {
              overdueAmount += outstanding;
            }
          }
        });

        setSummary({
          totalOutstanding,
          totalInvoices: response?.data?.totalCount || invoices.length,
          overdueAmount,
        });
      } else {
        toast.error("Failed to fetch summary");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        customer: id,
        search: tabledata?.search,
        payment: tabledata?.payment,
        delivery_status: tabledata?.delivery_status,
        date: tabledata?.date,
        page: tabledata?.currentPage,
        limit: 10, 
      };

      const response = await get_all_invoices(params);

      if (response?.status) {
        let invoices = response?.data?.data || [];

        invoices = invoices.filter(
          (invoice) => calculateOutstanding(invoice) > 0
        );

        const startIndex = ((params.page || 1) - 1) * params.limit;
        const paginatedInvoices = invoices.slice(
          startIndex,
          startIndex + params.limit
        );

        const tableData = paginatedInvoices.map((invoice) => {
          const outstanding = calculateOutstanding(invoice);

          return {
            path: `/app/billing/view/${invoice?._id}`,
            "Invoice No": `#${invoice.number}`,
            Date: new Date(invoice.date).toLocaleDateString(),
            "Due Date": invoice.due_date
              ? new Date(invoice.due_date).toLocaleDateString()
              : "-",
            "Total Amount": `OMR ${invoice.total?.toFixed(3)}`,
            "Paid Amount": invoice.payments?.length
              ? invoice.payments
                  .map((p) => `${p.name}: ${p.amount.toFixed(3)}`)
                  .join(", ")
              : "0.000",
            Outstanding: `OMR ${outstanding.toFixed(3)}`,
            "Payment Status":
              invoice?.payment_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Paid
                </span>
              ) : invoice?.payment_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Unpaid
                </span>
              ),
            "Delivery Status":
              invoice?.delivery_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : invoice?.delivery_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
          };
        });

        setBody(tableData);

        setPagination({
          currentPage: params.page || 1,
          totalCount: invoices.length,
          totalPages: Math.ceil(invoices.length / params.limit),
        });
      } else {
        toast.error("Failed to fetch invoices");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    if (id) {
      fetchSummary();
      fetchData();
      headerReset();
    }
  }, [id]);

  return (
    <div>
      <Header headers={header} setHeaders={setHeader} formdata={formdata}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 mt-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Outstanding</h3>
            <p className=" text-red-600">
              OMR {summary.totalOutstanding.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Invoices</h3>
            <p className="text-green-600">{pagination.totalCount}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Overdue Amount</h3>
            <p className=" text-orange-600">
              OMR {summary.overdueAmount.toFixed(3)}
            </p>
          </div>
        </div>
        <Loadercomponent loader={loader}>
          <Table
            head={tables}
            body={body}
            pagination={pagination}
            paginationdata={paginationdata}
          />
        </Loadercomponent>
      </Header>
    </div>
  );
};

export default CustomerOutstandingStatement;
